import React from "react";
import { Row, Col, Alert } from "antd";
import { PlusOutlined, MinusCircleOutlined } from "@ant-design/icons";
import { Form, FormItem, TextAreaItem, ButtonItem } from "./Items";

/**
 * Captura de las leyendas del complemento SAT "Leyendas Fiscales".
 *
 * El XSD permite de 1 a N nodos <leyendasFisc:Leyenda>. De los tres atributos
 * solo textoLeyenda es obligatorio; disposicionFiscal y norma son opcionales y
 * se omiten del XML cuando van vacios.
 *
 * Se usa en la pestaña Complementos del Cliente (donde se capturan los textos
 * por defecto) y en Agregar Venta / Generar Factura (donde se editan para esa
 * factura en particular).
 */
const FormListLeyendasFiscales = ({ name = "leyendasFiscales", mostrarAviso = false }) => {
  return (
    <>
      {mostrarAviso ? (
        <Alert
          message="Complemento de Leyendas Fiscales"
          description="Estas leyendas se precargan desde el cliente y se pueden editar para esta factura. Se timbran en el complemento leyendasFisc:LeyendasFiscales del CFDI y se imprimen en el PDF."
          type="info"
          showIcon
          style={{ marginBottom: 10 }}
        />
      ) : null}
      <Form.List name={name}>
        {(fields, { add, remove }) => (
          <>
            {fields.map(({ key, name: fieldName, ...restField }, index) => (
              <div
                key={key}
                style={{
                  marginBottom: 20,
                  padding: 15,
                  border: "1px solid #f0f0f0",
                  borderRadius: 5,
                }}
              >
                <Row gutter={16} align="middle">
                  <Col span={22}>
                    <FormItem
                      {...restField}
                      name={[fieldName, "textoLeyenda"]}
                      label={`Leyenda ${index + 1}`}
                      margin
                      labelCol={{ span: 6 }}
                      wrapperCol={{ span: 18 }}
                      rules={[{ required: true, message: "El texto de la leyenda es obligatorio" }]}
                      tooltip="Texto de la leyenda. Es el unico dato que el SAT exige."
                    >
                      <TextAreaItem rows={3} placeholder="Texto de la leyenda" />
                    </FormItem>
                    <FormItem
                      {...restField}
                      name={[fieldName, "disposicionFiscal"]}
                      label="Disposición Fiscal"
                      margin
                      labelCol={{ span: 6 }}
                      wrapperCol={{ span: 18 }}
                      tooltip="Opcional. Ley o disposición fiscal que motiva la leyenda."
                    >
                      <TextAreaItem rows={2} placeholder="Ej: Art. 29 Fracc. I de la Ley del I.V.A." />
                    </FormItem>
                    <FormItem
                      {...restField}
                      name={[fieldName, "norma"]}
                      label="Norma"
                      margin
                      labelCol={{ span: 6 }}
                      wrapperCol={{ span: 18 }}
                      tooltip="Opcional. Norma o regla especifica de la disposición fiscal."
                    >
                      <TextAreaItem rows={2} placeholder="Ej: Reglas 4.3.21, 5.2.5 y 5.2.6 de las RGCE vigentes" />
                    </FormItem>
                  </Col>
                  <Col span={2} style={{ textAlign: "center" }}>
                    <MinusCircleOutlined
                      style={{
                        fontSize: "18px",
                        color: "#ff4d4f",
                        cursor: "pointer",
                      }}
                      onClick={() => remove(fieldName)}
                      title="Eliminar leyenda"
                    />
                  </Col>
                </Row>
              </div>
            ))}
            <Row>
              <Col span={24}>
                <ButtonItem
                  type="dashed"
                  onClick={() => add()}
                  block
                  icon={<PlusOutlined />}
                >
                  Agregar Leyenda Fiscal
                </ButtonItem>
              </Col>
            </Row>
          </>
        )}
      </Form.List>
    </>
  );
};

export default FormListLeyendasFiscales;
